import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close() {
    this.element.removeAttribute("open")
  }

  closeIfOutside(event) {
    if (!this.element.hasAttribute("open")) return
    if (this.element.contains(event.target)) return

    this.close()
  }
}
